var exports = {
  "vK": "PremiumUpsellBanner.module__banner___T2pYT3",
  "Qs": "PremiumUpsellBanner.module__content___T2pYT3",
  "Qq": "PremiumUpsellBanner.module__text___T2pYT3",
  "Wz": "PremiumUpsellBanner.module__communityRow___T2pYT3",
  "ju": "PremiumUpsellBanner.module__communityIcon___T2pYT3",
  "nG": "PremiumUpsellBanner.module__communityMore___T2pYT3",
  "rT": "PremiumUpsellBanner.module__previewRow___T2pYT3",
  "kH": "PremiumUpsellBanner.module__previewItem___T2pYT3",
  "yY": "PremiumUpsellBanner.module__previewEmojiText___T2pYT3",
};

module.exports = exports;
